// import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../components/layout/Layout";
import Country from "../features/country/Country";
import User from "../features/user/User";
import CreateUser from "../features/user/CreateUser";
import UserType from "../features/userType/UserType";
import CreateUserType from "../features/userType/CreateUserType";
import Rights from "../features/rights/Rights";
import CreateRights from "../features/rights/CreateRights";
import Menu from "../features/menu/Menu";
import CreateMenu from "../features/menu/CreateMenu";
import City from "../features/city/City";
import State from "../features/state/State";
import PrivateRoute from "./PrivateRoute";
import Dashboard from "../features/dashboard/Dashboard";
import Nationality from "../features/nationality/Nationality";
import FlightPlace from "../features/FlightPlace/FlightPlace";
import Login from "../features/login/Login";
import UserManagement from "../features/userManagement/UserManagement";
import CreateUserManagement from "../features/userManagement/CreateUserManagement";
import FlightBooking from "../features/flightBooking/FlightBooking";
import FlightBookingView from "../features/flightBooking/FlightBookingView";
import AbandonedFlightBooking from "../features/abandonedFlightBooking/AbandonedFlightBooking";
import AdminSetting from "../features/adminsetting/AdminSetting";
import PromoCode from "../features/promocode/PromoCode";
import FlightBookingCancellation from "../features/flightbookingcancellation/FlightBookingCancellation";
import GiftCode from "../features/giftcode/GiftCode";
import AdminWalletUser from "../features/adminwalletuser/AdminWalletUser";
import WalletWithdrawalRequest from "../features/walletwithdrawal/WalletWithdrawalRequest";
import WalletWithdrawalRequestView from "../features/walletwithdrawal/WalletWithdrawalRequestView";
import AdminWalletTransactionView from "../features/adminwalletuser/AdminWalletTransactionView";
import MemberShipPlan from "../features/membershipplan/MemberShipPlan";
import WalletAmountReturn from "../features/walletamountreturn/WalletAmountReturn";
import RoomType from "../features/roomtype/RoomType";
import SpecialityType from "../features/specialitytype/SpecialityType";
import Sector from "../features/sector/Sector";
import CreateSector from "../features/sector/CreateSector";
import Itinerary from "../features/itinerary/Itinerary";
import CreateItinerary from "../features/itinerary/CreateItinerary";
import ItineraryFacility from "../features/ItineraryFacility/ItineraryFacility";
import VehicleSharingPax from "../features/vehiclesharingpax/VehicleSharingPax";
import Region from "../features/region/Region";
import Tour from "../features/tour/Tour";
import CreateTour from "../features/tour/CreateTour";
import Gst from "../features/gst/Gst";
import Currency from "../features/currency/Currency";
import Inquiry from "../features/inquiry/Inquiry";
import TourService from "../features/tourservice/TourService";
import CreateTourService from "../features/tourservice/CreateTourService";
import Logs from "../features/logs/Logs";
import Bank from "../features/bank/Bank";
import BankAccount from "../features/bankaccount/BankAccount";
import GiftCodeLedger from "../features/giftcode/GiftCodeLedger";
import TopupRequest from "../features/topuprequest/TopupRequest";
import TopupRequestView from "../features/topuprequest/TopupRequestView";
import CMS from "../features/cms/CMS";
import CreateCMS from "../features/cms/CreateCMS";
import Setting from "../features/setting/Setting";

const MainRouter = () => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route
          path="flightbooking/view/:PortalBookingNo/"
          element={<FlightBookingView />}
        />
        {/* <Route
          path="abandonedflightbooking/view/:id"
          element={<FlightBookingView />}
        /> */}
        <Route index={true} element={<Dashboard />} />
        <Route path="flightplaces" element={<FlightPlace />} />
        <Route path="flightbooking" element={<FlightBooking />} />
        <Route
          path="flightbooking/cancel"
          element={<FlightBookingCancellation />}
        />
        <Route
          path="abandonedflightbooking"
          element={<AbandonedFlightBooking />}
        />
        <Route path="nationality" element={<Nationality />} />
        <Route path="country" element={<Country />} />
        <Route path="city" element={<City />} />
        <Route path="gst" element={<Gst />} />
        <Route path="currency" element={<Currency />} />
        <Route path="promocode" element={<PromoCode />} />
        <Route path="giftcode" element={<GiftCode />} />
        <Route path="giftcodeledger" element={<GiftCodeLedger />} />
        <Route path="membershipplan" element={<MemberShipPlan />} />
        <Route path="state" element={<State />} />
        <Route path="bank" element={<Bank />} />
        <Route path="bankaccount" element={<BankAccount />} />
        <Route path="user" element={<User />} />

        <Route path="adminsetting" element={<AdminSetting />} />
        <Route path="user/create" element={<CreateUser />} />
        <Route path="user/edit" element={<CreateUser />} />
        <Route path="usermanage" element={<UserManagement />} />
        <Route path="usermanage/create" element={<CreateUserManagement />} />
        <Route path="usermanage/edit" element={<CreateUserManagement />} />
        <Route path="usertype" element={<UserType />} />
        <Route path="usertype/create" element={<CreateUserType />} />
        <Route path="usertype/edit" element={<CreateUserType />} />
        <Route path="rights" element={<Rights />} />
        <Route path="rights/create" element={<CreateRights />} />
        <Route path="rights/edit" element={<CreateRights />} />
        <Route path="menu" element={<Menu />} />
        <Route path="menu/create" element={<CreateMenu />} />
        <Route path="menu/edit" element={<CreateMenu />} />
        <Route path="roomtype" element={<RoomType />} />
        <Route path="specialitytype" element={<SpecialityType />} />
        <Route path="sector" element={<Sector />} />
        <Route path="sector/create" element={<CreateSector />} />
        <Route path="sector/edit" element={<CreateSector />} />
        <Route path="cms" element={<CMS />} />
        <Route path="setting" element={<Setting />} />
        <Route path="cms/create" element={<CreateCMS />} />
        <Route path="cms/edit" element={<CreateCMS />} />
        <Route path="itinerary" element={<Itinerary />} />
        <Route path="itinerary/edit" element={<CreateItinerary />} />
        <Route path="itinerary/create" element={<CreateItinerary />} />
        <Route path="tourservice" element={<TourService />} />
        <Route path="tourservice/edit" element={<CreateTourService />} />
        <Route path="tourservice/create" element={<CreateTourService />} />
        <Route path="inquiry" element={<Inquiry />} />
        <Route path="tour" element={<Tour />} />
        <Route path="tour/create" element={<CreateTour />} />
        <Route path="tour/edit" element={<CreateTour />} />
        <Route path="itineraryfacility" element={<ItineraryFacility />} />
        <Route path="vehiclesharingpax" element={<VehicleSharingPax />} />
        <Route path="region" element={<Region />} />
        <Route path="adminwalletuser" element={<AdminWalletUser />} />
        <Route
          path="adminwallettransaction"
          element={<AdminWalletTransactionView />}
        />
        <Route
          path="walletwithdrawalrequest"
          element={<WalletWithdrawalRequest />}
        />
        <Route
          path="walletwithdrawalrequestview"
          element={<WalletWithdrawalRequestView />}
        />
        <Route path="walletamountreturn" element={<WalletAmountReturn />} />
        <Route path="topuprequest" element={<TopupRequest />} />
        <Route path="topuprequest/view" element={<TopupRequestView />} />
        <Route path="logs" element={<Logs />} />
        <Route path="*" element={<h1>404</h1>} />
      </Route>
    </Routes>
  );
};

export default MainRouter;
